import React from 'react';
import { PriceLabel as StyledPriceLabel } from './PriceLabel.styled';

export interface PriceLabelProps {
  children: React.ReactNode;
  className?: string;
}

export function PriceLabel({ children, className }: PriceLabelProps) {
  return (
    <StyledPriceLabel className={className}>
      {children}
    </StyledPriceLabel>
  );
}
